import { useCurrentTenant } from "core/features/auth/tenant.store";
import { useState } from "react";
import FormasRecebimento from "components/Features/FormasRecebimento/TabelaFormaRecebimento";
import { Modal } from "antd";
import FooterModal from "components/Button/FooterModal";

function ModalFormasRecebimento({
  value,
  onChange,
  onClose,
  hideTaxas = false,
}: {
  value: string[];
  onChange: (v: string[]) => void;
  onClose: () => void;
  hideTaxas?: boolean,
}) {
  const { tenant } = useCurrentTenant();

  const [localValue, setLocalValue] = useState<string[]>(value);

  return (
    <>
      <Modal
        visible
        destroyOnClose
        width="750px"
        onCancel={onClose}
        footer={
          <FooterModal
            registerAnother={false}
            setRegisterAnother={() => null}
            onSubmit={() => {
              onChange(localValue);
              onClose();
            }}
            onClose={onClose}
            showRegisterAnother={false}
            primaryButtonText="Confirmar"
            buttonCancelarText="Voltar"
          />
        }
      >
        <FormasRecebimento
          value={localValue}
          tenantId={tenant.id}
          onChange={setLocalValue}
          ativo="1"
          hideTaxas={hideTaxas}
        />
      </Modal>
    </>
  );
}

export default ModalFormasRecebimento;
